import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from '../common/Cookies.js';
import { useAuth } from '../contexts/AuthContext';
import { useUserNotifications } from '../hooks/useUserNotifications';

export default function Logout({ setLoggedIn }) {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { disconnect } = useUserNotifications();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Step 1: Call server logout endpoint to remove ALL sessions for this user
        // This must be done BEFORE clearing cookies so the JWT token is still available
        const token = Cookies.getJwtToken() || localStorage.getItem('jwtToken');
        if (token) {
          try {
            console.log('Logout: Calling server logout endpoint to remove all user sessions...');
            await axios.post('/user-presence/logout', {}, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            console.log('Logout: Server logout successful - all user sessions removed');
          } catch (error) {
            console.error('Logout: Error calling server logout endpoint:', error);
            // Continue with logout even if server call fails
          }
        }

        // Step 2: Disconnect the STOMP notification connection
        if (disconnect) {
          console.log('Logout: Disconnecting user notification STOMP connection...');
          disconnect();
        }

        // Step 3: Small delay to ensure STOMP disconnect message is sent to server
        // before clearing cookies and navigating
        setTimeout(() => {
          Cookies.clearAll();
          localStorage.removeItem('jwtToken');
          axios.defaults.headers.common['Authorization'] = '';
          setUser(null);
          setLoggedIn(false);
          navigate('/Login');
        }, 100); // 100ms delay to allow STOMP disconnect to complete

      } catch (error) {
        console.error('Logout: Error during logout process:', error);
        // Even if there's an error, clear local state and navigate to login
        Cookies.clearAll();
        localStorage.removeItem('jwtToken');
        axios.defaults.headers.common['Authorization'] = '';
        setUser(null);
        setLoggedIn(false);
        navigate('/Login');
      }
    };

    performLogout();
  }, [disconnect, setUser, setLoggedIn, navigate]);

  return (
    <>
    </>
  );
}
